import {
	Button,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent, ModalFooter,
	ModalHeader,
	ModalOverlay,
	useDisclosure,
	HStack, 
	Spacer,
} from '@chakra-ui/react'
import React, {useEffect} from 'react'
import {UserButton} from '../UserButton/UserButton'
import {UserForm} from '../UserForm/UserForm'
import useForm from 'hooks/useForm/useForm'
import {useFormValidation} from 'hooks/useForm/useFormValidation'
import {useApiToast} from 'hooks/useApi/useApiToast'
import {UserAPI} from 'apis/UserAPI'
import { DeleteButton } from 'components/Users/DeleteButton'

export const UserModal = (props) => {
	// console.log(props)
	const {fetchUsers, mode, user} = props
	const {isOpen, onOpen, onClose} = useDisclosure()
	const {values, handleChange, clearValues, setValues} = useForm({})

	const { validateUser } = useFormValidation()
	const showApiToast = useApiToast()
	const saveUser = async () => {
		const validationErrors = validateUser(values)
		if (validationErrors.length === 0) {
			let resp
			if(values._id){
				console.log('update user')
				resp = await UserAPI.update(values._id, values)
			} else {
				console.log('create user')
				resp = await UserAPI.create(values)
			}

			showApiToast(resp)
			if(resp.status === 0){
				fetchUsers()
				clearValues()
				onClose()
			}

		}
	}
	useEffect(() => {
		setValues({ ...user})
	}, [props])
	return (
		<>
			<UserButton mode={mode} onOpen={onOpen}/>
			<Modal isOpen={isOpen} onClose={onClose}>
				<ModalOverlay/>
				<ModalContent>
					<ModalHeader></ModalHeader>
					<ModalCloseButton/>
					
					<ModalBody>
						<UserForm values={values} handleChange={handleChange} saveUser={saveUser}/>
					</ModalBody>
					<ModalFooter>
						<HStack spacing={4} alignItems='center' w='100%'>
							{values._id && 
								<DeleteButton 
									_id={values._id} name={`${user.name} ${user.last_name}`} 
									updateUserList={() => { onClose(); fetchUsers(); clearValues() }}
								/>
							}
							<Spacer/>
							<Button onClick={()=>saveUser(values)} colorScheme='blue'>
								Save
							</Button>
							<Button onClick={onClose}>Cancel</Button>
						</HStack>
						
					</ModalFooter>
				</ModalContent>
			</Modal>
		</>
	)
}